// EXTERNAL DEPENDENCIES ///////////////////////////////////////////////////////
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import Vue2Scrollbar from 'vue2-scrollbar';
import VueClipboard from 'vue-clipboard2';
import ElementUI from 'element-ui';
import Inputmask from 'inputmask';
import ShWysiwyg from '@ddosdor/vue-sh-wysiwyg';
import '@ddosdor/vue-sh-wysiwyg/lib/ShWysiwyg.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css';
import lang from 'element-ui/lib/locale/lang/pl';
import locale from 'element-ui/lib/locale';

// HOTJAR SCRIPT
import Hotjar from 'vue-hotjar';

// INTERNAL DEPENDENCIES ///////////////////////////////////////////////////////
import ShAuth from './plugins/ShAuth';
import { AUTHORIZATION_OPTIONS } from './config';
import router from '@/router';
import store from '@/store';
import App from '@/App';

// ADD ALL VUE FILTERS
import '@/filters';
import '@/directives';

// ADD STYLE ///////////////////////////////////////////////////////////////////
import './assets/styles/theme-ui/theme.css';
import './assets/styles/style.sass';

// REGISTER WIDGET INSTANCE COMPONENTS
import CallWebModalWindow from '@/components/WidgetInstance/callweb-modal-window/component';
import CallWebButton from '@/components/WidgetInstance/callweb-button/component';

Vue.component('CallWebModalWindow', CallWebModalWindow);
Vue.component('CallWebButton', CallWebButton);

// VUE CONFIG //////////////////////////////////////////////////////////////////
sync(store, router);
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$filters = Vue.options.filters;
Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(ShAuth, AUTHORIZATION_OPTIONS, store, router);
Vue.use(ShWysiwyg);
Vue.use(Hotjar, {
  id: '2776357',
  isProduction: true,
});
Vue.directive('mask', {
  bind(el, binding) {
    Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0]);
  },
});

// ELEMENT-UI //////////////////////////////////////////////////////////////////
locale.use(lang);
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

Vue.component('vue-scrollbar', Vue2Scrollbar);
